<template>
  <Teleport to="body">
    <div v-if="isOpen" class="fixed inset-0 z-50 overflow-y-auto" @click="closeModal">
      <!-- Background overlay -->
      <div class="fixed inset-0 bg-black bg-opacity-50 transition-opacity"></div>
      
      <!-- Modal -->
      <div class="flex min-h-full items-center justify-center p-4">
        <div 
          @click.stop
          class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6"
        >
          <!-- Success Icon -->
          <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
            <svg class="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
            </svg>
          </div>
          
          <!-- Content -->
          <div class="mt-3 text-center sm:mt-5">
            <h3 class="text-lg font-semibold leading-6 text-gray-900">
              {{ $t('Produkt hinzugefügt') }}
            </h3>
            <div class="mt-2">
              <p class="text-sm text-gray-500">
                <span v-if="quantity > 1">{{ quantity }}x </span>{{ productName }} 
                {{ $t('wurde erfolgreich zum Warenkorb hinzugefügt.') }}
              </p>
            </div>
          </div>
          
          <!-- Actions -->
          <div class="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
            <button
              type="button"
              @click="goToCart"
              class="inline-flex w-full justify-center rounded-md bg-sonnenglas-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-sonnenglas-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sonnenglas-600 sm:col-start-2"
            >
              {{ $t('Warenkorb anzeigen') }}
            </button>
            <button
              type="button"
              @click="closeModal"
              class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
            >
              {{ $t('Weiter einkaufen') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { inject } from 'vue'
import { router } from '@inertiajs/vue3'

interface Props {
  isOpen: boolean
  productName: string
  quantity: number
}

interface Emits {
  (e: 'close'): void
}

defineProps<Props>()
const emit = defineEmits<Emits>()

// Inject the route function
const route = inject<(name?: string, params?: any, absolute?: boolean) => string>('route')

const closeModal = () => {
  emit('close')
}

const goToCart = () => {
  closeModal()
  // Force reload cart page to get fresh data from backend
  router.visit(route?.('cart') || '/cart', {
    preserveState: false,
    preserveScroll: false,
  })
}
</script>